import Image from 'next/image'
import { format } from 'date-fns'

import { twMerge } from 'src/libs/tailwind-css'
import {
    CONTENT_CONTAINER_STYLES,
    HEADING_2_STYLES,
    LABEL_STYLES,
    PARAGRAPH_SMALL_STYLES,
} from 'src/libs/design-system'
import { ClockOutlinedIcon, CalendarOutlinedIcon } from 'src/libs/icons'
import { NextImage } from 'src/libs/types'
import { HtmlHead } from 'src/libs/html-head'

const DATE_FORMAT = 'E, MMM d, y'

interface HeaderProps {
    label?: string
    title: string
    image?: HeaderImageProps
    metadata?: HeaderMetaDataProps
}

export function Header({ label, title, image, metadata }: HeaderProps) {
    return (
        <>
            <div className={twMerge(CONTENT_CONTAINER_STYLES, 'max-w-xl text-center my-16')}>
                <HtmlHead title={title} imageUrl={image?.src.src} />
                {label && (
                    <div className={twMerge(PARAGRAPH_SMALL_STYLES, 'text-grey-700/60 pb-2')}>
                        {label}
                    </div>
                )}
                <h1 className={HEADING_2_STYLES}>{title}</h1>
                {metadata && <HeaderMetaData {...metadata} />}
            </div>
            {image && <HeaderImage {...image} />}
        </>
    )
}

interface HeaderImageProps {
    alt: string
    src: NextImage
}

function HeaderImage(props: HeaderImageProps) {
    return (
        <div className="my-16 px-2 box-content max-w-3xl mx-auto">
            <div className="rounded-3xl overflow-hidden">
                {/* eslint-disable-next-line jsx-a11y/alt-text */}
                <Image {...props} layout="responsive" priority />
            </div>
        </div>
    )
}

interface HeaderMetaDataProps {
    date: Date
    duration: number
}

function HeaderMetaData({ date, duration }: HeaderMetaDataProps) {
    return (
        <div
            className={twMerge(
                LABEL_STYLES,
                'grid gap-4 grid-flow-col justify-center mt-8 text-grey-700/60'
            )}
        >
            <div className="grid grid-flow-col gap-2 items-center">
                <CalendarOutlinedIcon className="h-4 w-4 text-grey-700/40" />
                {format(date, DATE_FORMAT)}
            </div>
            <div className="grid grid-flow-col gap-2 items-center">
                <ClockOutlinedIcon className="h-4 w-4 text-grey-700/40" />
                {duration} minutes
            </div>
        </div>
    )
}
